import { InsuranceOutput } from '@/graphql/generated'
import { createContext } from 'react'

export type AddInsuranceFormModalContextProps = {
  closeModal: () => void
  openModal: (insurance?: InsuranceOutput) => void
  insuranceData: InsuranceOutput | null
  isOpen: boolean
}

export const AddInsuranceFormModalContext = createContext<AddInsuranceFormModalContextProps | null>(null)